import { createSelector } from 'reselect'
import featureScopesSelector from './featureScopesSelector'

const isAirecEnabledSelector = createSelector(
    featureScopesSelector,
    (featureScopes): boolean => featureScopes.includes('airec'),
)

export default isAirecEnabledSelector
